import { render, staticRenderFns } from "./PFTools.vue?vue&type=template&id=0a13d5f8"
import script from "./PFTools.vue?vue&type=script&lang=js"
export * from "./PFTools.vue?vue&type=script&lang=js"
import style0 from "./PFTools.vue?vue&type=style&index=0&id=0a13d5f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports